import React from 'react';
import { BreadcrumbsSchema, DeeplinkSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import LoadingPage from 'components/pages/status/LoadingPage';
import OfflinePage from 'components/pages/status/OfflinePage';
import ContentPageLayout from 'components/ContentPageLayout';
import ContentTypeComponent from 'components/ContentTypeComponent';

import { MIJN_JUKE_PAGE_TITLE, MY_JUKE_SLUG_LOGGED_IN } from 'globalConst/const';
import { CONTENT_TYPES } from 'globalConst/contentTypes-const';
import { SCHEMA_MY_JUKE_DEEPLINK } from 'globalConst/schema-const';

import DynamicPage from 'components/pages/DynamicPage';

interface MyJukePageProps {
  isLoading: boolean;
  error: unknown;
  isOnline: boolean;
  isUserLoggedIn: boolean;
}

const MyJukePage = (props: MyJukePageProps): JSX.Element => {
  const { isLoading, error, isOnline, isUserLoggedIn } = props;
  if (isLoading && !error) {
    return (
      <ContentPageLayout>
        <LoadingPage />
      </ContentPageLayout>
    );
  }

  if (!isUserLoggedIn) {
    return <DynamicPage />;
  }

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <ContentPageLayout>
      <PageHeader title={MIJN_JUKE_PAGE_TITLE} />
      <BreadcrumbsSchema level2={MIJN_JUKE_PAGE_TITLE} />
      <DeeplinkSchema deeplinks={[{ link: SCHEMA_MY_JUKE_DEEPLINK }]} />
      <PageContent>
        <ContentTypeComponent contentTypeId={CONTENT_TYPES.OVERVIEW_COLLECTION} slug={MY_JUKE_SLUG_LOGGED_IN} />
      </PageContent>
    </ContentPageLayout>
  );
};

export default MyJukePage;
